import React,{useContext} from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AffordablePprices,SatisFaction,EasyBookingSvg,AvailableSvg,AppStoreSvg,PlayStoreSvg} from "./HomeSvg";
import { LanguageContext } from "../context/LanguageContext";
const WhyChoose = () => {
    const { translations } = useContext(LanguageContext);
  return (
    <div className="rm_why_choose padding_cmn" id="partner">
      <Container>
        <Row className="align-items-center">
          <Col lg={6}>
            <div className="why_choose_text">
              <h6 className="rm_subheading">{translations.WhyChoose?.subTitle }</h6>
              <h2 className="subTitle"  dangerouslySetInnerHTML={{ __html: translations.WhyChoose?.title }}>
              </h2>
              <p className="rm_why_text text-start">
              {translations.WhyChoose?.description }
              </p>
              <ul className="p-0 m-0">
                <li className="list-group-item d-flex gap-3">
                    {AffordablePprices}
                    <div className="rem_choose_grid">
                        <h5>{translations.WhyChoose?.services?.cheapest}</h5>
                        <p>{translations.WhyChoose?.services?.cheapestText }</p>
                    </div>
                </li>
                <li className="list-group-item d-flex gap-3">
                    {EasyBookingSvg}
                    <div className="rem_choose_grid">
                        <h5>{translations.WhyChoose?.services?.quick }</h5>
                        <p>{translations.WhyChoose?.services?.quickText }</p>
                    </div>
                </li>
                <li className="list-group-item d-flex gap-3">
                    {AvailableSvg}
                    <div className="rem_choose_grid">
                        <h5>{translations.WhyChoose?.services?.available }</h5>
                        <p>{translations.WhyChoose?.services?.availableText }</p>
                    </div>
                </li>
                <li className="list-group-item d-flex gap-3">
                    {SatisFaction}
                    <div className="rem_choose_grid">
                        <h5>{translations.WhyChoose?.services?.satisfaction }</h5>
                        <p>{translations.WhyChoose?.services?.satisfactionText }</p>
                    </div>
                </li>
              </ul>
              <div className="pt-3 d-flex">
                {AppStoreSvg} {PlayStoreSvg}
              </div>
            </div>
          </Col>
          <Col lg={6} className="text-center">
          <img src="/assets/images/why_choose.png" alt="rimlig image" className="img-fluid choose_rimligi_image" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WhyChoose;
